import React from 'react';
import { Link } from '../../../ui/Link';
import { Type } from '@spotify-internal/encore-web-v6';
import { useT } from '../../../../../features/src/i18n/index';
import androidIcon from '../../images/footer-android.svg';
import iosIcon from '../../images/footer-ios.svg';
import { useFooterLabels } from './useFooterLabels';
import { TRACK_CAT } from '../constants';
import styled from 'styled-components';

const AppsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
`;

export const GetTheApp = () => {
  const t = useT();
  const footerLabels = useFooterLabels();
  return (
    <>
      <Type variant="finaleBold" semanticColor="textBase">
        {t(
          'FRODOR_GET_THE_APP_SECTION_HEADER_FOOTER',
          'Get the app',
          'App is short for application',
        ).toUpperCase()}
      </Type>
      <AppsList>
        <Link
          data-testid="footer-ios"
          highlight
          external
          href="https://itunes.apple.com/us/app/spotify-for-artists/id1222021797"
          track={[TRACK_CAT, 'iOS App']}
        >
          <img
            data-src={iosIcon}
            alt={footerLabels.appStore}
            className="lazyload"
          />
        </Link>
        <Link
          data-testid="footer-android"
          highlight
          external
          href="https://play.google.com/store/apps/details?id=com.spotify.s4a"
          track={[TRACK_CAT, 'Android App']}
        >
          <img
            data-src={androidIcon}
            alt={footerLabels.googlePlay}
            className="lazyload"
          />
        </Link>
      </AppsList>
    </>
  );
};
